import { Api } from "../config/request";

export default {
  getCityList(queryParams) {
    return Api.get(
      `/locations/city${
        queryParams && queryParams.length > 0 ? `?${queryParams}` : ""
      }`
    );
  },
  getCity(payload) {
    const id = payload.id;
    return Api.get(`/locations/city/${id}`);
  },
  updateCity(id, payload) {
    return Api.put(`/locations/city/${id}`, payload);
  },
  createCity(payload) {
    return Api.post("/locations/city", payload);
  },
};
